module.exports = __webpack_public_path__ + "static/media/eye-red.3528cf98.png";